/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum OrganizationDocumentClassificationType {
  OTHER = "other",
  TDS = "tds",
  SDS = "sds",
  MARKETING_DOCUMENT = "marketing_document",
  COA = "coa",
  PRODUCT_DOSSIER = "product_dossier",
  REGULATORY_DOSSIER = "regulatory_dossier",
  ANIMAL_TESTING_STATEMENT = "animal_testing_statement",
  ALLERGENS_STATEMENT = "allergens_statement",
  BSE_TSE_STATEMENT = "bse_tse_statement",
  CALIFORNIA_PROP_65_STATEMENT = "california_prop_65_statement",
  CITES_STATEMENT = "cites_statement",
  COMPOSITION_STATEMENT = "composition_statement",
  CMR_STATEMENT = "cmr_statement",
  COUNTRY_OF_ORIGIN_STATEMENT = "country_of_origin_statement",
  GMO_STATEMENT = "gmo_statement",
  GLUTEN_STATEMENT = "gluten_statement",
  IMPURITIES_AND_CONTAMINANTS_STATEMENT = "impurities_and_contaminants_statement",
  ISO16128_STATEMENT = "iso16128_statement",
  MANUFACTURING_PROCESS_STATEMENT = "manufacturing_process_statement",
  MISC_FREE_FROM_STATEMENT = "misc_free_from_statement",
  NANOMATERIALS_STATEMENT = "nanomaterials_statement",
  ORIGIN_STATEMENT = "origin_statement",
  REACH_STATEMENT = "reach_statement",
  RSPO_STATEMENT = "rspo_statement",
  VEGAN_HALAL_KOSHER_STATEMENT = "vegan_halal_kosher_statement",
  STATEMENT = "statement",
  FORMULA_BATCH_SHEET = "formula_batch_sheet",
  QUANTITATIVE_FORMULA = "quantitative_formula",
  INGREDIENT_LIST = "ingredient_list",
  STABILITY_TEST = "stability_test",
  PACKAGING_COMPATIBILITY_TEST = "packaging_compatibility_test",
  PACKAGING_SPECIFICATION = "packaging_specification",
  ARTWORK = "artwork",
}
